/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BadRequestResponse,
  ForbiddenResponse,
  GetKnowledgePageContent200,
  GetKnowledgePageContent404,
  GetKnowledgebasePageContent200,
  GetKnowledgebasePageContent404,
  InternalServerErrorResponse,
  UnauthorizedResponse
} from '../model';

import { customInstance } from '../../custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Returns the markdown content of a specific page from a knowledge base document
 * @summary Get the markdown content of a knowledge base document page
 */
export const getKnowledgebasePageContent = (
    organizationId: string,
    knowledgeDocumentId: string,
    pageNumber: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetKnowledgebasePageContent200>(
      {url: `/organizations/${organizationId}/knowledge/${knowledgeDocumentId}/pages/${pageNumber}/content`, method: 'GET', signal
    },
      options);
    }




export const getGetKnowledgebasePageContentQueryKey = (organizationId: string,
    knowledgeDocumentId: string,
    pageNumber: string,) => {
    return [
    `/organizations/${organizationId}/knowledge/${knowledgeDocumentId}/pages/${pageNumber}/content`
    ] as const;
    }


export const getGetKnowledgebasePageContentQueryOptions = <TData = Awaited<ReturnType<typeof getKnowledgebasePageContent>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | GetKnowledgebasePageContent404 | InternalServerErrorResponse>(organizationId: string,
    knowledgeDocumentId: string,
    pageNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getKnowledgebasePageContent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetKnowledgebasePageContentQueryKey(organizationId,knowledgeDocumentId,pageNumber);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getKnowledgebasePageContent>>> = ({ signal }) => getKnowledgebasePageContent(organizationId,knowledgeDocumentId,pageNumber, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined && knowledgeDocumentId !== null && knowledgeDocumentId !== undefined && pageNumber !== null && pageNumber !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getKnowledgebasePageContent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetKnowledgebasePageContentQueryResult = NonNullable<Awaited<ReturnType<typeof getKnowledgebasePageContent>>>
export type GetKnowledgebasePageContentQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | GetKnowledgebasePageContent404 | InternalServerErrorResponse


export function useGetKnowledgebasePageContent<TData = Awaited<ReturnType<typeof getKnowledgebasePageContent>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | GetKnowledgebasePageContent404 | InternalServerErrorResponse>(
 organizationId: string,
    knowledgeDocumentId: string,
    pageNumber: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getKnowledgebasePageContent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKnowledgebasePageContent>>,
          TError,
          Awaited<ReturnType<typeof getKnowledgebasePageContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetKnowledgebasePageContent<TData = Awaited<ReturnType<typeof getKnowledgebasePageContent>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | GetKnowledgebasePageContent404 | InternalServerErrorResponse>(
 organizationId: string,
    knowledgeDocumentId: string,
    pageNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getKnowledgebasePageContent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKnowledgebasePageContent>>,
          TError,
          Awaited<ReturnType<typeof getKnowledgebasePageContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetKnowledgebasePageContent<TData = Awaited<ReturnType<typeof getKnowledgebasePageContent>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | GetKnowledgebasePageContent404 | InternalServerErrorResponse>(
 organizationId: string,
    knowledgeDocumentId: string,
    pageNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getKnowledgebasePageContent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the markdown content of a knowledge base document page
 */

export function useGetKnowledgebasePageContent<TData = Awaited<ReturnType<typeof getKnowledgebasePageContent>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | GetKnowledgebasePageContent404 | InternalServerErrorResponse>(
 organizationId: string,
    knowledgeDocumentId: string,
    pageNumber: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getKnowledgebasePageContent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetKnowledgebasePageContentQueryOptions(organizationId,knowledgeDocumentId,pageNumber,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns the content and preview URL for a specific page of a Knowledge Base document
 * @summary Get Knowledge Base document page content
 */
export const getKnowledgePageContent = (
    organizationId: string,
    documentId: string,
    pageId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetKnowledgePageContent200>(
      {url: `/organizations/${organizationId}/knowledge/documents/${documentId}/pages/${pageId}/content`, method: 'GET', signal
    },
      options);
    }




export const getGetKnowledgePageContentQueryKey = (organizationId: string,
    documentId: string,
    pageId: string,) => {
    return [
    `/organizations/${organizationId}/knowledge/documents/${documentId}/pages/${pageId}/content`
    ] as const;
    }


export const getGetKnowledgePageContentQueryOptions = <TData = Awaited<ReturnType<typeof getKnowledgePageContent>>, TError = UnauthorizedResponse | ForbiddenResponse | GetKnowledgePageContent404 | InternalServerErrorResponse>(organizationId: string,
    documentId: string,
    pageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getKnowledgePageContent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetKnowledgePageContentQueryKey(organizationId,documentId,pageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getKnowledgePageContent>>> = ({ signal }) => getKnowledgePageContent(organizationId,documentId,pageId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined && documentId !== null && documentId !== undefined && pageId !== null && pageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getKnowledgePageContent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetKnowledgePageContentQueryResult = NonNullable<Awaited<ReturnType<typeof getKnowledgePageContent>>>
export type GetKnowledgePageContentQueryError = UnauthorizedResponse | ForbiddenResponse | GetKnowledgePageContent404 | InternalServerErrorResponse


export function useGetKnowledgePageContent<TData = Awaited<ReturnType<typeof getKnowledgePageContent>>, TError = UnauthorizedResponse | ForbiddenResponse | GetKnowledgePageContent404 | InternalServerErrorResponse>(
 organizationId: string,
    documentId: string,
    pageId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getKnowledgePageContent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKnowledgePageContent>>,
          TError,
          Awaited<ReturnType<typeof getKnowledgePageContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetKnowledgePageContent<TData = Awaited<ReturnType<typeof getKnowledgePageContent>>, TError = UnauthorizedResponse | ForbiddenResponse | GetKnowledgePageContent404 | InternalServerErrorResponse>(
 organizationId: string,
    documentId: string,
    pageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getKnowledgePageContent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKnowledgePageContent>>,
          TError,
          Awaited<ReturnType<typeof getKnowledgePageContent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetKnowledgePageContent<TData = Awaited<ReturnType<typeof getKnowledgePageContent>>, TError = UnauthorizedResponse | ForbiddenResponse | GetKnowledgePageContent404 | InternalServerErrorResponse>(
 organizationId: string,
    documentId: string,
    pageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getKnowledgePageContent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Knowledge Base document page content
 */

export function useGetKnowledgePageContent<TData = Awaited<ReturnType<typeof getKnowledgePageContent>>, TError = UnauthorizedResponse | ForbiddenResponse | GetKnowledgePageContent404 | InternalServerErrorResponse>(
 organizationId: string,
    documentId: string,
    pageId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getKnowledgePageContent>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetKnowledgePageContentQueryOptions(organizationId,documentId,pageId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






